'use strict';

define('form-value-animation',['jquery'], function ($) {

  // using constant instead of hardcoded values
  var HAS_VALUE_CLASS = 'has-value';

  var $form = $('.contour').find('form'),
      $elements = $form.find('input[type="text"], textarea, select');

  // event handlers
  var handlers = {
    focus: function() {
      $(this).parent().addClass(HAS_VALUE_CLASS);
    },
    blur: function() {
      refreshValueState($(this));
    }
  };

  // init function
  var initialize = function() {
    initFields();
    attachEvents();
  };

  // init fields func
  var initFields = function() {
    $elements.each(function() {
      refreshValueState($(this));
    });
  };

  // attaching event handlers on elements' events
  var attachEvents = function() {
    $elements.focus(handlers.focus);
    $elements.blur(handlers.blur);
  };

  // refreshing velue state of the fields $el
  var refreshValueState = function($el) {
    var val = $el.val();

    // if any text in the field exists
    if(val) {
      $el.parent().addClass(HAS_VALUE_CLASS);
    }
    else {
      // if there are any of white space chars
      if(val.length) {
        $el.val('');
      }
      $el.parent().removeClass(HAS_VALUE_CLASS);
    }
  };

  return {
    init: initialize
  };

});
